// extracted by mini-css-extract-plugin
export default {"home":"Home_home__RkxK3","logomh":"Home_logomh__cBvvy","center":"Home_center__fgfs5"};